
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],staticStyle:{"enable-background":"new 0 0 22 20"},style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"x":"0px","y":"0px","width":"22px","height":"20px","viewBox":"0 0 22 20","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M15.7,6.5h-3.2V4.4c0-0.8,0.5-1,0.9-1c0.4,0,2.3,0,2.3,0V0l-3.1,0C9.1,0,8.3,2.6,8.3,4.2v2.3h-2V10h2c0,4.5,0,10,0,10h4.2c0,0,0-5.5,0-10h2.8L15.7,6.5z"}})])
      }
    
      }
    